import { ROUTES, withLocale } from "@/config/routes";
import { historyModalStore } from "@/shared/stores/HistoryModalStore";
import { Cross, Share } from "@cronika/assets/icons";
import { useTranslation } from "@cronika/locales";
import { Button, cn } from "@cronika/ui";
import { observer } from "mobx-react-lite";
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { HistoryBlock } from "../modules/history-module";

export const HistoryModal: FC = observer(() => {
  const { t: tLayout } = useTranslation("layout");
  const { t } = useTranslation("trading");
  const [hasScroll, setHasScroll] = useState(false);

  if (!historyModalStore.isOpen) return null;

  return (
    <>
      <div className="absolute inset-0 z-40" onClick={() => historyModalStore.close()} />
      <div
        className={cn(
          "absolute inset-y-0 left-2 top-10 z-50 flex h-[440px] w-[350px] flex-col overflow-hidden bg-[#8C8C8C]/15 pl-2 py-2 rounded-lg backdrop-blur-xl animate-in slide-in-from-left-4 fade-in-0 duration-200",
          !hasScroll && "pr-2",
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between px-1 pb-2">
          <p className="text-[14px] font-medium">{tLayout("sidebar.history-btn")}</p>
          <Button
            isIconOnly
            variant="ghost"
            radius="lg"
            className="h-6 w-6"
            aria-label={tLayout("sidebar.history-btn")}
            onClick={() => historyModalStore.close()}
          >
            <Cross className="h-6 w-6" />
          </Button>
        </div>

        <div className="min-h-0 flex-1">
          <HistoryBlock variant="flyout" onOverflowChange={setHasScroll} />
        </div>

        <Link
          to={withLocale(ROUTES.HISTORY)}
          onClick={() => historyModalStore.close()}
          className="mt-2 flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-lg border border-accent-warm/15 bg-accent-warm/15 text-[14px] font-semibold text-warning mr-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clip-path="url(#clip0_7976_31690)">
              <path
                d="M10.1111 14H2.33332C1.71002 14 1.12409 13.7573 0.683395 13.3165C0.242705 12.8758 0 12.2899 0 11.6667V3.88888C0 3.26562 0.242733 2.67968 0.683423 2.23899C1.12411 1.7983 1.71005 1.55556 2.33335 1.55556H5.44445C5.87403 1.55556 6.22223 1.90377 6.22223 2.33335C6.22223 2.76292 5.87403 3.11113 5.44445 3.11113H2.33332C2.12555 3.11113 1.93026 3.19204 1.78338 3.33892C1.6365 3.4858 1.55556 3.68112 1.55556 3.88888V11.6667C1.55556 11.8744 1.63648 12.0697 1.78338 12.2166C1.93026 12.3635 2.12555 12.4444 2.33332 12.4444H10.1111C10.3188 12.4444 10.5141 12.3635 10.661 12.2166C10.8079 12.0697 10.8888 11.8744 10.8888 11.6666V8.55555C10.8888 8.12597 11.237 7.7778 11.6666 7.7778C12.0962 7.7778 12.4444 8.126 12.4444 8.55555V11.6667C12.4444 12.2899 12.2017 12.8758 11.761 13.3166C11.3203 13.7573 10.7343 14 10.1111 14ZM5.44445 9.33331C5.24538 9.33331 5.04633 9.25739 4.89448 9.10552C4.59075 8.80179 4.59075 8.30929 4.89448 8.00556L11.3444 1.55556H8.55555C8.12597 1.55556 7.7778 1.20736 7.7778 0.777782C7.7778 0.348205 8.12597 0 8.55555 0H13.2222C13.3298 0 13.4322 0.0218443 13.5254 0.0613216C13.6124 0.0981092 13.6941 0.151416 13.7655 0.221269L13.7656 0.221323C13.7661 0.221839 13.7666 0.222328 13.7671 0.222845C13.7672 0.22298 13.7674 0.223143 13.7676 0.223279C13.7679 0.22366 13.7684 0.224067 13.7688 0.224475C13.769 0.224746 13.7693 0.224991 13.7695 0.225263C13.7698 0.225561 13.7702 0.225888 13.7704 0.226132C13.771 0.226675 13.7716 0.227246 13.7721 0.227817C13.7726 0.22836 13.7732 0.228958 13.7738 0.229501C13.7741 0.229773 13.7744 0.230126 13.7746 0.23037C13.7749 0.230642 13.7751 0.230887 13.7754 0.231158C13.7759 0.231566 13.7762 0.231946 13.7766 0.232381C13.7767 0.23249 13.7769 0.23268 13.777 0.232816C13.7776 0.233332 13.7781 0.233848 13.7786 0.234364L13.7786 0.234419C13.8484 0.305929 13.9018 0.387601 13.9385 0.474543C13.978 0.567735 13.9999 0.670164 13.9999 0.777755V5.44442C13.9999 5.874 13.6517 6.2222 13.2221 6.2222C12.7925 6.2222 12.4443 5.874 12.4443 5.44442V2.65552L5.99428 9.10554C5.84254 9.25742 5.64349 9.33331 5.44445 9.33331Z"
                fill="#F4A425"
              />
            </g>
            <defs>
              <clipPath id="clip0_7976_31690">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {t("history.view-all")}
        </Link>
      </div>
    </>
  );
});
